import { AppHeaderStyle, HeaderStyle, Section, SectionSeparatorRow } from "./styles";
import FollowGoogle from "@/shared/FollowGoogle";
import {
  NewsToday,
  Liveblogs,
  Menu,
  HeadingDefault,
  UrgentModule,
} from "./components";
import { useAppTrue } from "@/hooks/index";
import Banner from "@/widgets/Banner/Templates/Banner";
import { ContainerAuto } from "@/shared/ContainerAuto";
import Script from "next/script";
import { useContext, useState, useEffect } from "react";
import { useRouter } from "next/router";
import TemplateContext from "@/context/Template/TemplateContext";
import SeparatorLinksRecipes from "@/shared/SeparatorLinksRecipes";
import { SubMenuArq } from "@/shared/SubMenuArq";

const Header = (props) => {
  const router = useRouter();
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const isDesktop = () => window.innerWidth > 1024;

    const handleScroll = () => {
      setScroll((prev) => {
        const threshold = isDesktop() ? 446 : 36;
        return window.scrollY > threshold;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};

  if (formatContent?.dataHeader) {
    props = {
      ...props,
      ...formatContent?.dataHeader,
    };
  }

  const {
    urgent = [],
    liveblogs,
    menu,
    bannerHorizantalOneEnable = true,
    subheaderEnable = true,
    isNews = false,
    isHome = false,
    showGoolgeOneTap = true,
    newsToday,
    hideNewsToday = false,
    megaWithHtml = false,
    nameIcon = "logoClarin",
    heightIcon,
    cssClass = "",
    titleHeader = "",
    isTitleHeader,
    TAGTitleHeader = "h1",
    showLinkRecipes = false,
    showLiveblog = true,
    showBannerH1App = true,
    logoUrlSection = "",
    submenu = {},
    hideSectionScroll = false,
  } = props;

  const menulateral = menu?.menulateral?.item?.items ?? [];
  const menuheader = menu?.menuheader?.item?.items ?? [];
  const menuHeaderMobileHome = menu?.menuheadermobile?.item?.items ?? [];

  const sectionData = props.sectionData
    ? props.sectionData
    : { name: "", url: null };

  const isApp = useAppTrue();

  const urlIsMundial2026 = formatContent?.landing?.url?.includes("copa-mundial-2026") || router?.asPath?.includes("copa-mundial-2026");
  const urlIsRecipes = formatContent?.landing?.url?.includes("recetas") || router?.asPath?.includes("recetas");


  if (isApp)
    return (
      <>
        {bannerHorizantalOneEnable && showBannerH1App && (
          <AppHeaderStyle>
            <div className="bannerTopHeader">
              <Banner isPreview={props.isPreview} slotId={"horizontal1"} />
            </div>
          </AppHeaderStyle>
        )}
        <Script src="/js/appClarin.js" strategy="beforeInteractive" />
      </>
    );
  return (
    <>
      <HeaderStyle>
        {bannerHorizantalOneEnable && (
          <div className={`bannerTopHeader ${scroll ? "sticky" : "no-sticky"}`}>
            <Banner isPreview={props.isPreview} slotId={"horizontal1"} />
          </div>
        )}
        {bannerHorizantalOneEnable && <div className="spacer" />}

        <HeadingDefault
          isHome={isHome}
          isNews={isNews}
          sectionData={sectionData}
          suscriptionPrice={
            menu?.suscriptionPrice ? menu?.suscriptionPrice : ""
          }
          menulateral={menulateral}
          subheaderEnable={subheaderEnable}
          showGoolgeOneTap={showGoolgeOneTap}
          isPreview={props.isPreview}
          nameIcon={nameIcon}
          heightIcon={heightIcon}
          cssClass={cssClass}
          isTitleHeader={isTitleHeader || urlIsRecipes}
          urlIsRecipes={urlIsRecipes}
          titleHeader={titleHeader}
          TAGTitleHeader={TAGTitleHeader}
          logoUrlSection={logoUrlSection}
          bannerHorizantalOneEnable={bannerHorizantalOneEnable}
          logoVariant={scroll ? "sticky" : isHome ? "home" : "default"} // establece margen-left logo claríon 80 aniversario
          hideSectionScroll={hideSectionScroll}
        />

        {!hideNewsToday && newsToday && bannerHorizantalOneEnable && (
          <NewsToday noticiashoy={newsToday} />
        )}

        {isHome && (
          <Menu
            menuheader={menuheader}
            sectionData={sectionData}
            menuHeaderMobileHome={menuHeaderMobileHome}
            suscriptionPrice={
              menu?.suscriptionPrice ? menu?.suscriptionPrice : ""
            }
            isPreview={props.isPreview ? props.isPreview : false}
          />
        )}

        {!megaWithHtml && subheaderEnable && showLiveblog ? (
          <Liveblogs liveblogs={liveblogs || []} />
        ) : (
          <></>
        )}

        {Array.isArray(urgent) && urgent.length > 0 && (
          <UrgentModule urgent={urgent} />
        )}
        {showLinkRecipes && !urlIsRecipes && <SeparatorLinksRecipes />}

        {(submenu?.item?.items?.length > 0 || titleHeader) && !urlIsMundial2026 && (
          <SubMenuArq
            title={titleHeader}
            items={submenu?.item?.items ?? []}
            isTitleHeader={isTitleHeader || urlIsRecipes}
          />
        )}
        {showLinkRecipes && urlIsRecipes &&<SeparatorLinksRecipes />}


        {isNews && subheaderEnable && !megaWithHtml ? (
          <ContainerAuto>
            <SectionSeparatorRow>
              <Section
                className="SectionSeparator"
                href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/${
                  sectionData.url != undefined ? sectionData.url : ""
                }`}
              >
                {sectionData.name}
              </Section>
              <FollowGoogle
                className="btn-add-google-header"
                href="https://www.google.com/preferences/source?q=clarin.com"
                icon
                text="Agregar Clarín en"
                iconGoogle
              />
            </SectionSeparatorRow>
          </ContainerAuto>
        ) : (
          <></>
        )}
      </HeaderStyle>
    </>
  );
};

export default Header;